import { createSlice, createAsyncThunk, createEntityAdapter } from "@reduxjs/toolkit";
import consultatioformlinkApiController from "services/consultationformlink.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import { contentErrorMessage } from "./contentError";
export const usersAdapter = createEntityAdapter();

const consultationFormLinkErrorMessage = (action, fallback) => contentErrorMessage(action, fallback);

export const consultationformDetailApi = createAsyncThunk("consultationform/view", async (formValues, thunkAPI) => {
  try {
    const resposedata = await consultatioformlinkApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "consultationform"))
      .catch((error) => HandleError(thunkAPI, error, "consultationform"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  isConsultationStep: 1,
  isConsultationStepName: "",
  isDetailData: "",
  isDetailDataError: "",
  isApiStatus: {
    consultationformDetailApi: "",
  },
};

const consultationformSlice = createSlice({
  name: "consultationform",
  initialState,
  reducers: {
    reset: () => initialState,
    PreviewStep: (state, action) => {
      state.isConsultationStep = action.payload - 1;
    },
    NextStep: (state, action) => {
      state.isConsultationStep = action.payload + 1;
    },
    ConsultationStepName: (state, action) => {
      state.isConsultationStepName = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(consultationformDetailApi.pending, (state) => {
        state.isDetailDataError = "";
        state.isApiStatus = { ...state.isApiStatus, consultationformDetailApi: "loading" };
      })
      .addCase(consultationformDetailApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, consultationformDetailApi: "succeeded" };
        state.isDetailData = action.payload;
        state.isDetailDataError = "";
      })
      .addCase(consultationformDetailApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, consultationformDetailApi: "failed" };
        state.isDetailDataError = consultationFormLinkErrorMessage(action, "Unable to load the consultation form.");
      });
  },
});

export const { ConsultationStepName, PreviewStep, NextStep } = consultationformSlice.actions;
export default consultationformSlice.reducer;
